import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_LOCALE = 'locale/SET';

export const setLocale = createAction(SET_LOCALE);
